import BaseChart from './BaseChart';

/**
 * Treemap chart implementation using VChart
 */
class TreemapChart extends BaseChart {
  /**
   * Get chart specification for treemap chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    // Treemap specific fields — auto-detect from data when not provided
    const nameField = this.options.nameField || this._resolveNameField();
    const valueField = this._resolveValueField();
    const childrenField = this.options.childrenField || 'children';
    const colorField = this.options.colorField || 'depth';
    
    return {
      type: 'treemap',
      data,
      nameField,
      valueField,
      childrenField,
      colorField,
      
      // Padding configuration
      padding: this.options.padding || 4,
      
      // Color configuration
      color: {
        type: 'ordinal',
        ...this.options.colorScale
      },
      
      // Treemap specific styling
      treemap: {
        style: {
          stroke: '#fff',
          lineWidth: 1,
          ...this.options.treemapStyle
        },
        state: {
          hover: {
            stroke: '#fff',
            lineWidth: 2
          },
          ...this.options.treemapState
        }
      },
      
      // Label configuration
      label: {
        visible: this.options.showLabels !== false,
        style: {
          fontSize: 12,
          fontWeight: 'normal',
          ...this.options.labelStyle
        },
        formatter: this.options.labelFormatter || ((datum) => {
          return datum[nameField];
        })
      },
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
  
  /**
   * Prepare hierarchical data for VChart format
   * @returns {Array} Formatted data for VChart
   */
  prepareData() {
    // If data is already in hierarchical format
    return [
      {
        id: 'treemapData',
        values: this.data
      }
    ];
  }
}

export default TreemapChart; 